var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-notification',{attrs:{"closable":false}},[_c('strong',[_vm._v(_vm._s(_vm.$t(
        'compCarbonFormsRactivitiesComponentsAstroHelpCalculatingMethod.title-1'
      )))]),_c('br'),_c('span',{domProps:{"innerHTML":_vm._s(
        _vm.$t(
          'compCarbonFormsRactivitiesComponentsAstroHelpCalculatingMethod.info-1'
        )
      )}})]),_c('b-notification',{attrs:{"closable":false}},[_c('strong',[_vm._v(_vm._s(_vm.$t(
        'compCarbonFormsRactivitiesComponentsAstroHelpCalculatingMethod.title-2'
      )))]),_c('br'),_c('strong',[_c('em',[_vm._v(_vm._s(_vm.$t(
          'compCarbonFormsRactivitiesComponentsAstroHelpCalculatingMethod.title-2-1'
        )))])]),_c('br'),_c('span',{domProps:{"innerHTML":_vm._s(
        _vm.$t(
          'compCarbonFormsRactivitiesComponentsAstroHelpCalculatingMethod.info-2-1'
        )
      )}}),_c('br'),_c('br'),_c('span',{staticStyle:{"padding-left":"100px"},domProps:{"innerHTML":_vm._s(_vm.renderFormula(_vm.formula1))}}),_c('br'),_c('br'),_c('span',{domProps:{"innerHTML":_vm._s(
        _vm.$t(
          'compCarbonFormsRactivitiesComponentsAstroHelpCalculatingMethod.info-2-1b'
        )
      )}}),_c('br'),_c('br'),_c('strong',[_c('em',[_vm._v(_vm._s(_vm.$t(
          'compCarbonFormsRactivitiesComponentsAstroHelpCalculatingMethod.title-2-2'
        )))])]),_c('br'),_c('span',{domProps:{"innerHTML":_vm._s(
        _vm.$t(
          'compCarbonFormsRactivitiesComponentsAstroHelpCalculatingMethod.info-2-2'
        )
      )}}),_c('br'),_c('br'),_c('span',{staticStyle:{"padding-left":"100px"},domProps:{"innerHTML":_vm._s(_vm.renderFormula(_vm.formula2))}})]),_c('b-notification',{attrs:{"closable":false}},[_c('strong',[_vm._v(_vm._s(_vm.$t(
        'compCarbonFormsRactivitiesComponentsAstroHelpCalculatingMethod.title-3'
      )))]),_c('br'),_c('span',{domProps:{"innerHTML":_vm._s(
        _vm.$t(
          'compCarbonFormsRactivitiesComponentsAstroHelpCalculatingMethod.info-3'
        )
      )}})]),_c('b-notification',{attrs:{"closable":false}},[_c('strong',[_vm._v(_vm._s(_vm.$t(
        'compCarbonFormsRactivitiesComponentsAstroHelpCalculatingMethod.title-4'
      )))]),_c('br'),_c('ul',{staticStyle:{"list-style-type":"square","margin-left":"25px"}},[_c('li',[_c('span',{domProps:{"innerHTML":_vm._s(
            _vm.$t(
              'compCarbonFormsRactivitiesComponentsAstroHelpCalculatingMethod.ref-4-1'
            )
          )}})]),_c('li',[_c('span',{domProps:{"innerHTML":_vm._s(
            _vm.$t(
              'compCarbonFormsRactivitiesComponentsAstroHelpCalculatingMethod.ref-4-2'
            )
          )}})])])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }